import * as yup from 'yup'

const LoginSchema = yup.object().shape({
    email: yup.string().required('Email is required').email('Enter a valid email'),
    password: yup.string().required('Password is required')
})

const ForgotPasswordSchema = yup.object().shape({
    email: yup.string().required('Email is required').email('Enter a valid email')
})

const ResetPasswordSchema = yup.object().shape({
    new_password: yup.string().required('Password is required').min(8, 'Minimum 8 character required'),
    confirm_password: yup.string().required('Confirm Password is required').oneOf([yup.ref('new_password'), null], 'Password does not match')
})

const DriverSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup.string().required("Email is required").email("Enter a valid email"),
    password: yup.string().required("Password is required").min(8, "Minimum 8 character required"),
    // city: yup.string().required("City is required"),
    profile: yup.string().required("Profile image is required"),
    ccode: yup.string().required("Country code is required"),
    phone: yup.string().required("Phone number is required"),
    ccode: yup.string().required("Code is required"),
    licence_number: yup.string().required("Licence number is required"),
    confirm_password: yup.string().oneOf([yup.ref('password')], "Password does not match").required("Confirm password is required")
})

const addFundSchema = yup.object().shape({
    // app_user_id: yup.string().required("Uniqe Id is required"),
    amount: yup.string().required("Amount is required"),
    amount: yup
        .number()
        .typeError("Amount be a number")
        .min(1, "Amount must be greater than 0")
        .required("Amount is required"),
})


const ProductSchema = yup.object().shape({
    category_id: yup.string().required('Category is required'),
    product_name: yup.string().required('Product name is required'),
    note: yup.string().required('Note is required')
    // price: yup.string().required('Price is required'),
    //service_charge: yup.string().required('Service charge is required')
})

const AddAssignmentSchema = yup.object().shape({
    branch: yup.string().required('Branch is required'),
    name: yup.string().required('Assignment name is required'),
    datetime: yup
        .string()
        .required('Date & Time is required')
        .test(
            'is-future-date',
            'Date & Time cannot be in the past',
            value => {
                if (!value) return false; // Value agar null ya empty ho toh false return karega
                const date = new Date(value);
                if (isNaN(date.getTime())) return false; // Agar invalid date ho toh false return karega
                return date > new Date(); // Past date ke liye false return karega
            }
        ),
})

const ConfirmOrder = yup.object().shape({
    assignment_id: yup.string().required('Assignment is required'),
})

const AddBranchSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    city: yup.string().required('City is required'),
    email: yup.string().required("Email is required").email("Enter a valid email"),
    phone: yup.string().required('Phone is required').min(9, 'Please enter valid phone number').max(15, 'Phone number cannot exceed 15 digits'),
    ccode: yup.string().required('Code is required'),
    name: yup.string().required('Name is required'),
    password: yup.string().required('Password is required').min(8, 'Minimum 8 character required'),
    confirm_password: yup.string().required('Confirm password is required').oneOf([yup.ref('password'), null], 'Password does not match')
})

const productSummarySchama = yup.object().shape({
    // cargo: yup.number().required("Cargo charge is required").positive("Cargo charge must be a positive value"),
    // air_cargo: yup.number().required("Air cargo is required").positive("Air cargo must be a positive value")
    cargo: yup
        .number()
        .typeError("Cargo charge must be a number")
        .min(1, "Cargo charge must be greater than 0")
        .required("Cargo charge is required"),

    air_cargo: yup
        .number()
        .typeError("Air cargo must be a number")
        .min(1, "Air cargo must be greater than 0")
        .required("Air cargo is required"),
})

const recommendationSchema = yup.object().shape({
    profile: yup.mixed().required("Image is required"),
    name: yup.string().required("Name is required"),
    link: yup.string().required("Link is required").url("Enter a valid link"),
    offer: yup.string().required("Offer is required"),
    description: yup.string().required("Description is required")
})

const verifyOtpSchema = yup.object({
    otp: yup.string()
        .required("OTP is required")
        .length(4, "OTP must be 4 digits"),
});

export { LoginSchema, AddBranchSchema, ForgotPasswordSchema, ConfirmOrder, ResetPasswordSchema, DriverSchema, addFundSchema, ProductSchema, AddAssignmentSchema, productSummarySchama, recommendationSchema, verifyOtpSchema }
